module.exports = __webpack_public_path__ + "static/display-message-above-shipping-options-on-checkout-page-183c1ac4112698563c17c788fbff70bf.png";